import classNames from 'classnames'

import { exists } from '~/utils'

import styles from './styles.css'
import { type StyledButtonCommonProps } from './types'

type GetButtonClassNameParams = StyledButtonCommonProps & {
  className?: string
}

export const getButtonClassName = ({
  buttonStyle = 'normal',
  className,
  noPadding,
}: GetButtonClassNameParams) =>
  classNames(
    styles.root,
    styles[buttonStyle ?? 'normal'],
    {
      [styles[`noPadding-${noPadding}`]]: exists(noPadding),
    },
    className,
  )
